import LocationService from '../services/location.service';
import { Location } from './models/models';

const queryProps = {
  filters: {},
  sort: [],
  page: 1,
  limit: 30,
};

export default {
  namespaced: true,
  state: {
    locationModal: {
      locationAddedCallback: null,
      locationType: null,
      isOpen: false,
      isNewLocation: null,
    },
    locationId: null,
    totalLocations: null,
    query: {},
  },
  mutations: {
    resetLocationModal(state) {
      state.locationModal = {
        isOpen: false,
        isNewLocation: null,
        locationType: null,
        locationAddedCallback: null,
      };
      state.locationId = null;
    },
    locationModal(state, props) {
      const locationModal = { ...state.locationModal };

      Object.keys(props)
        .forEach((field) => {
          locationModal[field] = props[field];
        });

      state.locationModal = locationModal;
    },
    locationId(state, locationId) {
      state.locationId = locationId;
    },
    totalLocations(state, totalLocations) {
      state.totalLocations = totalLocations;
    },
    initQueries(state) {
      const types = ['job', 'company'];
      types.forEach((locationType) => {
        state.query[locationType] = {
          ...queryProps,
          locationType,
        };
      });
    },
    queryProps(state, payload) {
      state.query[payload.locationType] = Object
        .assign({}, state.query[payload.locationType], payload.props);
      state.query = { ...state.query };
    },
  },
  actions: {
    init({ commit }) {
      commit('initQueries');
    },
    newLocation({ commit }, type) {
      Location.new()
        .then((location) => {
          location.$update({ type: type });
          commit('locationId', location.id);
        });
    },
    openLocationModal({ commit }, payload) {
      const parentLocationId = payload.hasOwnProperty('parentLocationId') ? payload.parentLocationId : null;
      commit('locationModal', {
        isNewLocation: !parentLocationId,
        locationType: payload.type,
        isOpen: true,
      });
      if (parentLocationId) {
        commit('locationId', parentLocationId);
      }

      return new Promise((resolve) => {
        commit('locationModal', {
          locationAddedCallback: resolve,
        });
      }).catch((e) => console.log(e));
    },
    newLocationAdded({ state }, location) {
      if (state.locationModal.locationAddedCallback) {
        state.locationModal.locationAddedCallback(location);
      }
    },
    updateLocationProps({ state }, props) {
      Location.update({
        where: state.locationId,
        data: props,
      });
    },
    getLocations({ commit, state }, locationType) {
      const locationProps = state.query[locationType];
      return LocationService.getLocations(locationProps)
        .then((res) => {
          commit('totalLocations', res.total);
          Location.create({
            data: res.data,
            insertOrUpdate: ['countries', 'regions'],
          });
        });
    },
    getLocation({ commit }, id) {
      return LocationService.getLocation(id)
        .then((location) => {
          commit('locationId', location.id);
          Location.insert({ data: [location] });
          return location;
        });
    },
    suggestLocations(store, params) {
      return LocationService.suggestLocations(params);
    },
    createLocation({ getters }) {
      return LocationService.createLocation(getters.location);
    },
    updateLocation({ getters, dispatch }) {
      return LocationService.updateLocation(getters.location)
        .then((res) => {
          if (res.hasOwnProperty('location_id')) {
            dispatch('getLocation', res.location_id);
          }
          return res;
        });
    },
    deleteLocation({ getters }) {
      return LocationService.deleteLocation(getters.location)
        .then((res) => {
          if (res.hasOwnProperty('location_id')) {
            Location.delete(res.location_id);
          }
          return res;
        });
    },
  },
  getters: {
    locations() {
      return Location.query()
        .with(['country', 'region'])
        .get();
    },
    location(state) {
      if (!state.locationId) {
        return null;
      }

      return Location.query()
        .withAllRecursive()
        .find(state.locationId);
    },
  },
};
